// extracted by mini-css-extract-plugin
export default {"switchWrapper":"Switch__switchWrapper___X7Slu"};